
import * as __star__ from 'react-dropzone';

const {
default: __default__,
ErrorCode,
useDropzone,
__esModule
} = __star__;

export {
ErrorCode,
useDropzone,
__esModule
};
export default __default__;
